import type { GachaSession } from '../types/pack';
import type { RarityTier } from '../types/card';

export const RARITY_ORDER: RarityTier[] = ['common', 'uncommon', 'rare', 'epic', 'legendary'];

export const BASE_WEIGHTS: Record<RarityTier, number> = {
  common: 50,
  uncommon: 28,
  rare: 15,
  epic: 5,
  legendary: 2
};

export interface PityConfig {
  softLegendaryStart?: number;
  hardLegendaryAt?: number;
  hardEpicAt?: number;
}

const DEFAULT_PITY: Required<PityConfig> = {
  softLegendaryStart: 80,
  hardLegendaryAt: 90,
  hardEpicAt: 20
};

export function getRarityWeights(
  session: GachaSession,
  config: PityConfig = DEFAULT_PITY
): Record<RarityTier, number> {
  const weights = { ...BASE_WEIGHTS };
  const pity = { ...DEFAULT_PITY, ...config };

  if (session.pullsSinceLegendary >= pity.softLegendaryStart) {
    const boost = (session.pullsSinceLegendary - pity.softLegendaryStart + 1) * 5;
    weights.legendary += boost;
    weights.common = Math.max(0, weights.common - boost);
  }

  return weights;
}

export function resolveGuaranteeRarity(
  session: GachaSession,
  config: PityConfig = DEFAULT_PITY
): RarityTier | undefined {
  const pity = { ...DEFAULT_PITY, ...config };

  if (session.pullsSinceLegendary >= pity.hardLegendaryAt) {
    return 'legendary';
  }

  if (session.pullsSinceEpic >= pity.hardEpicAt) {
    return 'epic';
  }

  return undefined;
}

export function rarityLabel(rarity: RarityTier): string {
  return rarity.charAt(0).toUpperCase() + rarity.slice(1);
}

